import * as Yup from "yup";
import Alert from "../../utils/Alert.js";
import { addNewInstallmentService, editInstallmentService } from "../../services/installmentsServices.js";
import { convertDateToGregorian } from "../../utils/convertDate.js";

export const initialValues = {
    amount: "",
    pay_date: "",
    is_paid: false,
}

export const initialTouched = {
    amount: true,
    pay_date: true,
}

export const onSubmit = async (values, actions, editingInstallment, setInstallments, setIsOpen, orderData, setEditingId, setEditingInstallment) => {
    const data = {
        ...values,
        pay_date: convertDateToGregorian(values.pay_date),
        order: orderData.id,
        user: orderData.user.id
    };
    try {
        if (editingInstallment) {
            const response = await editInstallmentService(orderData.code, editingInstallment.id, data);
            if (response.status === 200) {
                setInstallments(prevValues => prevValues.map(i => {
                    if (i.id === editingInstallment.id) {
                        return response.data;
                    }
                    return i;
                }));
                Alert("انجام عملیات", "قسط با موفقیت تغییر یافت", "success");
                setEditingId(null);
                setEditingInstallment(null);
                return setIsOpen(false);
            }
        } else {
            const response = await addNewInstallmentService(data);
            if (response.status === 200) {
                setInstallments(prevValues => [...prevValues, response.data]);
                Alert("انجام عملیات", "قسط با موفقیت ایجاد شد", "success");
                return actions.resetForm();
            }
        }
    } catch (error) {

    }
}

export const validationSchema = Yup.object({
    amount: Yup.number().required("لطفاً مبلغ قسط را وارد کنید")
        .typeError("لطفاً فقط عدد وارد کنید")
        .min(1, "مبلغ قسط نمیتواند 0 یا منفی باشد"),
    pay_date: Yup.string().required("لطفاً مهلت پرداخت قسط را مشخص کنید"),
    is_paid: Yup.boolean()
});
